import { FC, RefObject } from 'react';
import { Box, Flex } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Text from 'components/_core/Text';
import { getPlanType } from 'features/Onboarding/common/planUtils';
import amountWithMinorCurrency from 'features/Onboarding/modules/PricingPlan/helpers/amountWithMinorCurrency';

import hasDiscount from '../../../../lib/hasDiscount';
import { OnboardingPlanDisplay } from '../../../../types';
import PlanPrice from '../../../PlanPrice';
import locales from './locales';

const getPackagePriceTaxMention = (shouldShowPackagePriceWithVAT: boolean) =>
  shouldShowPackagePriceWithVAT ? locales.vat.included : locales.vat.excluded;

interface StickyMobileButtonProps {
  plan: OnboardingPlanDisplay;
  progressRef: RefObject<HTMLDivElement>;
  shouldShowPackagePriceWithVAT: boolean;
  isSelected: boolean;
  onChoose: (plan: OnboardingPlanDisplay) => void;
}

const StickyMobileButton: FC<StickyMobileButtonProps> = ({
  isSelected,
  onChoose,
  plan,
  progressRef,
  shouldShowPackagePriceWithVAT,
}) => {
  const displayedPrice = amountWithMinorCurrency(
    hasDiscount(plan) && plan.discountPrice !== null
      ? plan.discountPrice
      : plan.price,
  );

  return (
    <Box
      backdropFilter="blur(4px)"
      backgroundColor="rgba(255, 255, 255, 0.7)"
      borderTop="1px solid"
      borderTopColor="grey.2"
      padding="space-16"
      position="relative"
      width="100%"
    >
      <Box
        background="grey.400"
        borderRadius={8}
        height={4}
        left={0}
        position="absolute"
        ref={progressRef}
        top={0}
        transformOrigin="0 0"
        width="100%"
      />
      <Flex alignItems="center" justifyContent="space-between">
        <Flex flexDirection="column">
          <Flex alignItems="flex-end" gap="space-8">
            <PlanPrice
              value={displayedPrice}
              withoutCents={Number.isInteger(displayedPrice)}
            />
            <Text marginBottom="space-2">
              {plan.providerPackageId
                ? getPackagePriceTaxMention(shouldShowPackagePriceWithVAT)
                : locales.formatString(locales.perMonth, {
                    taxMention: locales.vat.excluded,
                  })}
            </Text>
          </Flex>
          {plan.providerPackageId ? null : (
            <Text fontSize="13px" variant="light">
              {plan.trialPeriod}{' '}
              {locales.formatString(locales.trialPeriod, {
                plural: plan.trialPeriod > 1 ? 's' : '',
              })}
            </Text>
          )}
        </Flex>

        <Button
          data-testid={`button-${getPlanType(plan.providerPlanId)}`}
          icon={isSelected ? undefined : 'arrow-right'}
          isDisabled={isSelected}
          onClick={() => onChoose(plan)}
          variant="primary"
        >
          {isSelected ? locales.selectedButton : locales.choseButton}
        </Button>
      </Flex>
    </Box>
  );
};

export default StickyMobileButton;
